// 引入ResizeObserver补丁并立即应用
import { applyResizeObserverPatch, setupResizeObserverErrorHandler } from './utils/resize-observer-patch'

// 立即应用错误处理器
setupResizeObserverErrorHandler()

import { createApp } from 'vue'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
// 引入Ant Design Vue
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/reset.css'
// import 'ant-design-vue/dist/antd.css'
import App from './App.vue'
import router from './router'
import { createPinia } from 'pinia'
import axios from 'axios'
import MockAdapter from 'axios-mock-adapter'

// 引入ECharts组件
import { use } from 'echarts/core'
import { BarChart, LineChart, PieChart, GraphChart, RadarChart } from 'echarts/charts'
import {
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  GridComponent,
  ToolboxComponent,
  DataZoomComponent
} from 'echarts/components'
import { CanvasRenderer } from 'echarts/renderers'
import VChart from 'vue-echarts'

// 注册ECharts组件
use([
  BarChart,
  LineChart,
  PieChart,
  GraphChart,
  RadarChart,
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  GridComponent,
  ToolboxComponent,
  DataZoomComponent,
  CanvasRenderer
])

// 引入自定义样式
import './assets/styles/main.css'
// import './assets/styles/global.less'
import 'font-awesome/css/font-awesome.min.css'

// 引入客户类型UI差异化渲染框架
// 暂时注释掉有问题的导入，改为直接在Vue应用中注册组件
// import DynamicComponents from './components/customer/dynamic/index.ts'
// 使用手动方式导入所需组件
import { registerDynamicComponents } from './components/customer/dynamic/index.ts'

// mock数据处理 - 使用Vue CLI的方式
// 注意：这里不进行任何加载，由vue.config.js配置进行处理
const isProd = process.env.NODE_ENV === 'production'
const useMock = process.env.VUE_APP_USE_MOCK === 'true'

// 只有在非生产环境或显式启用mock的情况下加载mock数据
if (!isProd || useMock) {
  console.log(`当前环境: ${isProd ? '生产环境' : '开发环境'}, 是否使用mock数据: ${useMock}`)
  // Mock服务器已在 vue.config.js 的 devServer.setupMiddlewares 中启动
  // 不需要在浏览器端导入 mock-server.js

  // 不再需要单独导入service实例，我们直接使用request

  // 创建MockAdapter实例，拦截service实例而不是全局axios
  // 导入service而不是axios
  const request = require('./utils/request').default;
  
  // 判断是否使用API模式或拦截器模式
  const useMockServer = process.env.VUE_APP_USE_MOCK_SERVER === 'true' || true; // 强制使用API服务模式
  
  // 特殊API模拟控制标志
  const ENABLE_FLOW_DATA_MOCK = false; // 是否模拟流向数据API
  const ENABLE_RAW_DATA_MOCK = true;   // 是否模拟原始数据API - 设为true启用模拟
  const ENABLE_DATA_ANALYSIS_MOCK = true; // 仍然启用数据分析API的模拟
  
  console.log(`【Mock】流向数据API模拟: ${ENABLE_FLOW_DATA_MOCK ? '已启用' : '已禁用'}`);
  console.log(`【Mock】原始数据API模拟: ${ENABLE_RAW_DATA_MOCK ? '已启用' : '已禁用'}`);
  console.log(`【Mock】数据分析API模拟: ${ENABLE_DATA_ANALYSIS_MOCK ? '已启用' : '已禁用'}`);
  
  // 使用try-catch包装MockAdapter创建，避免可能的错误
  let mock;
  try {
    if (!useMockServer) {
      // 只有在非API服务模式下才创建MockAdapter
      mock = new MockAdapter(request, { 
        delayResponse: 500,
        onNoMatch: 'passthrough'
      });
      console.log('[DEBUG] MockAdapter 实例已创建成功');
    } else {
      // API服务模式下，创建一个空的mock对象，不拦截任何请求
      mock = {
        onAny: () => ({ reply: () => {} }),
        onPost: () => ({ reply: () => {} }),
        onGet: () => ({ reply: () => {} }),
        reset: () => {}
      };
      console.log('[DEBUG] API服务模式，MockAdapter已禁用');
    }
  } catch (error) {
    console.error('[DEBUG] MockAdapter 创建失败:', error);
    // 创建一个空的mock对象，避免后续代码出错
    mock = {
      onAny: () => ({ reply: () => {} }),
      onPost: () => ({ reply: () => {} }),
      onGet: () => ({ reply: () => {} }),
      reset: () => {}
    };
  }
  console.log('[DEBUG] MockAdapter 实例状态:', useMockServer ? '已禁用' : '已启用');
  
  // 对特定API禁用拦截 - 使用try-catch避免可能的错误
  if (!useMockServer) {
    // 只有在非API服务模式下才配置MockAdapter拦截器
    try {
      mock.onAny(url => {
        try {
          if (!url) return null; // 保护：如果URL为空，使用默认处理
          
          // 检查URL类型
          const isFlowDataURL = url.includes('/flow-data/') || url.includes('/api/flow-data/');
          const isRawDataURL = url.includes('/raw-data/') || url.includes('/api/raw-data/');
          const isDataAnalysisURL = url.includes('/data-analysis/');
          const isCustomerDetailURL = url.includes('/api/customers/') && url.match(/\/api\/customers\/[^\/]+$/);
          
          // 如果是客户详情API，跳过拦截，让它走真实的Mock服务器
          if (isCustomerDetailURL) {
            console.log(`【Mock】跳过拦截客户详情API: ${url}`);
            return false; // 返回false表示不拦截
          }
          
          // 如果是流向数据URL且禁用了流向数据模拟，跳过拦截
          if (isFlowDataURL && !ENABLE_FLOW_DATA_MOCK) {
            console.log(`【Mock】跳过拦截流向数据API: ${url}`);
            return false; // 返回false表示不拦截
          }
          
          // 如果是原始数据URL且禁用了原始数据模拟，跳过拦截
          if (isRawDataURL && !ENABLE_RAW_DATA_MOCK) {
            console.log(`【Mock】跳过拦截原始数据API: ${url}`);
            return false; // 返回false表示不拦截
          }
          
          // 如果是原始数据URL且启用了原始数据模拟，明确指定需要拦截
          if (isRawDataURL && ENABLE_RAW_DATA_MOCK) {
            console.log(`【Mock】拦截原始数据API: ${url}`);
            return true; // 返回true表示拦截并处理
          }
          
          // 如果是数据分析URL且启用了数据分析模拟，允许拦截
          if (isDataAnalysisURL && ENABLE_DATA_ANALYSIS_MOCK) {
            console.log(`【Mock】允许拦截数据分析API: ${url}`);
            return null; // 返回null表示使用默认行为
          }
          
          // 默认情况下，根据模式决定是否拦截
          return null; // 返回null表示使用默认行为
        } catch (error) {
          console.error('【Mock】URL检查出错:', error);
          return null; // 出错时使用默认行为
        }
      });
    } catch (error) {
      console.error('【Mock】设置URL拦截器失败:', error);
    }
  } else {
    console.log('[DEBUG] API服务模式，跳过MockAdapter拦截器配置');
  }
  
  // 根据模式决定是否使用拦截器
  if (!useMockServer) {
    // 使用拦截器
    mockServer.interceptRequests(mock);
    console.log('[DEBUG] Mock拦截器已应用');
    
    // 配置具体的API拦截器
    // 直接处理文件上传接口 - 支持全路径匹配
    mock.onPost(RegExp('https?://.*?/api/upload')).reply(config => {
      console.log('[DEBUG] 拦截到文件上传请求 (全路径): ', config.url);
      return [200, {
        code: 200,
        message: '文件上传成功',
        data: {
          fileId: `mock_file_${Date.now()}`,
          fileName: 'uploaded_file.xlsx',
          fileSize: 1024 * 1024 * 2,
          uploadTime: new Date().toISOString()
        }
      }];
    });
    
    // 直接处理文件上传接口
    mock.onPost('/upload').reply(config => {
      console.log('[DEBUG] 拦截到文件上传请求: /upload');
      return [200, {
        code: 200,
        message: '文件上传成功',
        data: {
          fileId: `mock_file_${Date.now()}`,
          fileName: 'uploaded_file.xlsx',
          fileSize: 1024 * 1024 * 2,
          uploadTime: new Date().toISOString()
        }
      }];
    });
    
    // 处理api前缀的文件上传接口
    mock.onPost('/api/upload').reply(config => {
      console.log('[DEBUG] 拦截到文件上传请求: /api/upload');
      return [200, {
        code: 200,
        message: '文件上传成功',
        data: {
          fileId: `mock_file_${Date.now()}`,
          fileName: 'uploaded_file.xlsx',
          fileSize: 1024 * 1024 * 2,
          uploadTime: new Date().toISOString()
        }
      }];
    });
    
    // 处理数据导入接口 - 支持全路径匹配
    mock.onPost(RegExp('https?://.*?/api/data-process/import')).reply(config => {
      console.log('[DEBUG] 拦截到数据导入请求 (全路径): ', config.url);
      return [200, {
        code: 200,
        message: '数据导入成功',
        data: {
          importId: `IMP-${Date.now().toString().slice(-8)}`,
          taskName: '数据导入任务',
          dataType: 'sales_flow',
          totalRecords: Math.floor(Math.random() * 10000) + 1000,
          successRecords: Math.floor(Math.random() * 8000) + 800,
          errorRecords: Math.floor(Math.random() * 100),
          warningRecords: Math.floor(Math.random() * 200),
          importTime: new Date().toISOString(),
          status: 'success'
        }
      }];
    });
    
    // 处理数据导入接口
    mock.onPost('/api/data-process/import').reply(config => {
      console.log('[DEBUG] 拦截到数据导入请求: /api/data-process/import');
      return [200, {
        code: 200,
        message: '数据导入成功',
        data: {
          importId: `IMP-${Date.now().toString().slice(-8)}`,
          taskName: '数据导入任务',
          dataType: 'sales_flow',
          totalRecords: Math.floor(Math.random() * 10000) + 1000,
          successRecords: Math.floor(Math.random() * 8000) + 800,
          errorRecords: Math.floor(Math.random() * 100),
          warningRecords: Math.floor(Math.random() * 200),
          importTime: new Date().toISOString(),
          status: 'success'
        }
      }];
    });
    
    // 处理数据标准化映射建议接口 - 支持全路径匹配
    mock.onGet(RegExp('https?://.*?/api/data-process/standardization/mapping-suggestions/.*')).reply(config => {
      console.log('[DEBUG] 拦截到数据标准化映射建议请求 (全路径):', config.url);
      const importId = config.url.split('/').pop();
      
      return [200, {
        code: 200,
        message: '获取字段映射建议成功',
        data: {
          importId,
          sourceFields: [
            { field: 'drug_name', type: 'string', description: '药品名称' },
            { field: 'specification', type: 'string', description: '规格' },
            { field: 'manufacturer', type: 'string', description: '生产厂家' },
            { field: 'quantity', type: 'number', description: '数量' },
            { field: 'date', type: 'date', description: '日期' }
          ],
          standardFields: [
            { field: 'drug_name', type: 'string', description: '药品名称', required: true },
            { field: 'specification', type: 'string', description: '规格', required: true },
            { field: 'manufacturer', type: 'string', description: '生产厂家', required: true },
            { field: 'quantity', type: 'number', description: '数量', required: true },
            { field: 'transaction_date', type: 'date', description: '交易日期', required: true }
          ],
          mappingSuggestions: [
            { sourceField: 'drug_name', targetField: 'drug_name', confidence: 0.95 },
            { sourceField: 'specification', targetField: 'specification', confidence: 0.95 },
            { sourceField: 'manufacturer', targetField: 'manufacturer', confidence: 0.95 },
            { sourceField: 'quantity', targetField: 'quantity', confidence: 0.95 },
            { sourceField: 'date', targetField: 'transaction_date', confidence: 0.9 }
          ],
          previewData: [
            {
              drug_name: '阿莫西林胶囊',
              specification: '0.25g*24粒',
              manufacturer: '哈药集团制药总厂',
              quantity: 150,
              date: '2023-07-05'
            }
          ]
        }
      }];
    });
    
    // 处理原始数据API - 获取原始数据列表
    mock.onGet('/api/raw-data/list').reply(config => {
      console.log('[DEBUG] 拦截到原始数据列表请求:', config.url, config.params);
      try {
        // 解析查询参数
        const { page = 1, pageSize = 10, dataType, status } = config.params || {};
        
        // 直接使用模块
        const rawDataModule = require('./mock/api/raw-data/index');
        if (Array.isArray(rawDataModule)) {
          // 查找匹配路由
          const listRoute = rawDataModule.find(route => 
            route.url === '/api/raw-data/list' && route.method === 'get');
          
          if (listRoute && typeof listRoute.response === 'function') {
            console.log('[DEBUG] 使用注册的原始数据列表处理函数');
            const response = listRoute.response({
              query: config.params || {}
            });
            return [200, response];
          }
        }
        
        // 如果找不到处理函数，使用默认实现
        console.log('[DEBUG] 使用默认原始数据列表处理函数');
        
        // 生成模拟数据
        const generateMockData = (count) => {
          const result = [];
          
          const dataTypes = ['pure_sales', 'delivery', 'inventory'];
          const statuses = ['pending', 'processing', 'completed', 'failed'];
          
          for (let i = 0; i < count; i++) {
            const mockDataType = dataType || dataTypes[Math.floor(Math.random() * dataTypes.length)];
            const mockStatus = status || statuses[Math.floor(Math.random() * statuses.length)];
            
            result.push({
              id: `${i + 1}`,
              sourceName: `药店流向数据${20231115 + i}`,
              dataType: mockDataType,
              status: mockStatus,
              recordCount: Math.floor(Math.random() * 1000) + 100,
              collectionTime: `2023-11-${15 + (i % 15)} ${10 + (i % 10)}:${30 + (i % 30)}:00`
            });
          }
          
          return result;
        };
        
        const list = generateMockData(100);
        
        // 根据查询参数过滤
        let filteredList = list;
        
        if (dataType) {
          filteredList = filteredList.filter(item => item.dataType === dataType);
        }
        
        if (status) {
          filteredList = filteredList.filter(item => item.status === status);
        }
        
        // 分页
        const startIndex = (page - 1) * pageSize;
        const endIndex = startIndex + Number(pageSize);
        const pagedList = filteredList.slice(startIndex, endIndex);
        
        return [200, {
          code: 200,
          message: '获取原始数据列表成功',
          data: {
            list: pagedList,
            total: filteredList.length,
            page: Number(page),
            pageSize: Number(pageSize)
          }
        }];
      } catch (error) {
        console.error('[DEBUG] 处理原始数据列表请求出错:', error);
        return [500, { code: 500, message: '服务器错误', data: null }];
      }
    });
    
    // 处理原始数据详情API - 支持路径参数形式
    mock.onGet(new RegExp('/api/raw-data/detail/\\w+')).reply(config => {
      console.log('[DEBUG] 拦截到原始数据详情请求:', config.url);
      try {
        // 从URL中提取ID
        const id = config.url.split('/').pop();
        console.log('[DEBUG] 提取到ID:', id);
        
        // 使用mock模块
        const rawDataModule = require('./mock/api/raw-data/index');
        if (Array.isArray(rawDataModule)) {
          // 查找详情路由
          const detailRoute = rawDataModule.find(route => 
            route.url.startsWith('/api/raw-data/detail') && route.method === 'get');
          
          if (detailRoute && typeof detailRoute.response === 'function') {
            console.log('[DEBUG] 使用注册的原始数据详情处理函数');
            const response = detailRoute.response({
              params: { id },
              url: config.url
            });
            return [200, response];
          }
        }
        
        // 默认返回模拟数据
        return [200, {
          code: 200,
          message: '获取原始数据详情成功',
          data: {
            info: {
              id,
              sourceName: `药店流向数据${id}`,
              dataType: 'pure_sales',
              sourceType: 'file',
              status: 'pending',
              recordCount: 256,
              collectionTime: '2023-11-15 10:30:00',
              collector: '系统管理员',
              createTime: '2023-11-15 10:30:00',
              updateTime: '2023-11-15 10:30:00',
              remarks: '每日常规数据导入'
            },
            rawData: [
              {
                '商务大区': '华东区',
                '连锁名称': '上海连锁',
                '产品名称': '感冒灵颗粒',
                '规格': '10g*10袋',
                '单位': '盒',
                '销售数量': 150,
                '批号': 'BH20230515',
                '销售日期': '2023-06-15',
                '销售价格': 23.5,
                '客户名称': '某某药店',
                '省份': '上海',
                '城市': '上海市',
                '区县': '浦东新区'
              },
              {
                '商务大区': '华北区',
                '连锁名称': '北京连锁',
                '产品名称': '布洛芬片',
                '规格': '10mg*12片',
                '单位': '盒',
                '销售数量': 200,
                '批号': 'BH20230523',
                '销售日期': '2023-06-16',
                '销售价格': 15.8,
                '客户名称': '某某大药房',
                '省份': '北京',
                '城市': '北京市',
                '区县': '朝阳区'
              }
            ],
            processingHistory: []
          }
        }];
      } catch (error) {
        console.error('[DEBUG] 处理原始数据详情请求出错:', error);
        return [500, { code: 500, message: '服务器错误', data: null }];
      }
    });
    
    // 处理原始数据导出API
    mock.onGet('/api/raw-data/export').reply(config => {
      console.log('[DEBUG] 拦截到原始数据导出请求:', config.url, config.params);
      
      // 创建一个模拟的Blob对象作为下载内容
      const data = new Blob(['模拟导出数据内容'], { type: 'text/plain' });
      
      // 返回成功响应
      return [200, data];
    });
    
    // 关键API单独处理，保持最小侵入性
    const userModule = require('./mock/api/system/user');
    if (userModule && userModule.routes) {
      // 登录接口
      const loginRoute = userModule.routes.find(route => 
        route.url === '/api/user/login' && route.method === 'post');
      if (loginRoute) {
        mock.onPost('/user/login').reply(config => {
          try {
            console.log('[DEBUG] 拦截到登录请求: /user/login');
            // 解析请求体为JSON对象
            const requestBody = JSON.parse(config.data);
            console.log('[DEBUG] 登录请求数据:', requestBody);
            
            // 验证用户名和密码
            const { username, password } = requestBody;
            
            // 使用userModule中的response方法处理
            const response = loginRoute.response({
              body: requestBody
            });
            return [200, response];
          } catch (error) {
            console.error('[DEBUG] 处理登录请求出错:', error);
            return [500, { code: 500, message: '服务器错误', data: null }];
          }
        });
      }
    }

    // 导入规则引擎mock配置，这里使用动态导入来处理ESM模块
    import('./mock/rule-engine').then(ruleEngineModule => {
      console.log('规则引擎Mock初始化成功')
      // 使用默认导出进行注册
      mockServer.registerMock(ruleEngineModule.default)
    }).catch(err => {
      console.error('规则引擎Mock加载失败:', err)
    })
    
    // 添加请求拦截器，打印所有请求 - 只在拦截器模式下启用
    axios.interceptors.request.use(request => {
      console.log('[DEBUG] 发送请求:', request.method, request.url);
      return request;
    });
    
    // 修改响应拦截器以处理数据格式问题 - 只在拦截器模式下启用
    axios.interceptors.response.use(response => {
      console.log('[DEBUG] 收到响应:', response.status, response.config.url);
      
      // 检查是否是客户API，如果是则不进行格式转换
      const isCustomerAPI = response.config.url && (
        response.config.url.includes('/customers') || 
        response.config.url.includes('/api/customers')
      );
      
      if (isCustomerAPI) {
        console.log('[DEBUG] 客户API响应，跳过格式转换');
        return response;
      }
      
      // 确保数据存在并处理格式
      if (typeof response.data === 'object' && response.data !== null) {
        if (!response.data.code && !response.data.success) {
          // 尝试标准化响应
          response.data = {
            code: 200,
            data: response.data,
            message: '操作成功'
          };
          console.log('[DEBUG] 标准化响应格式');
        }
      }
      
      console.log('[DEBUG] 处理后的响应数据:', response.data);
      return response;
    }, error => {
      console.error('[DEBUG] 请求错误:', error.config?.url, error.message);
      return Promise.reject(error);
    });
  } else {
    console.log('[DEBUG] 使用API服务模式，不启用拦截器');
    console.log('[DEBUG] 客户详情API将直接发送到Mock服务器(9090端口)');
  }
}

// 全局错误处理
const handleGlobalError = (error) => {
  console.error('全局捕获的错误:', error)
  // 可以在这里添加错误上报逻辑
}

// 创建Pinia实例
const pinia = createPinia()

// 创建应用实例
const app = createApp(App)

// 全局错误处理
app.config.errorHandler = handleGlobalError

// 使用插件
app.use(ElementPlus)
app.use(Antd) // 使用Ant Design Vue
app.use(pinia)
app.use(router)
// 改用手动注册组件的方式
registerDynamicComponents(app) // 使用客户类型UI差异化渲染框架

// 全局注册VChart组件
app.component('v-chart', VChart);

// 导入需要的Ant Design Icons图标
import {
  HomeOutlined,
  EditOutlined,
  HistoryOutlined,
  ApartmentOutlined,
  SolutionOutlined,
  FileOutlined,
  UploadOutlined,
  AuditOutlined,
  FileSearchOutlined,
  CheckOutlined,
  InfoCircleOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
  ClockCircleOutlined,
  ConnectionOutlined,
  ThunderboltOutlined,
  SearchOutlined,
  PlusOutlined,
  DeleteOutlined,
  ExclamationCircleOutlined,
  DownloadOutlined,
  TableOutlined,
  LinkOutlined,
  FormOutlined,
  FilterOutlined,
  FunctionOutlined,
  TranslationOutlined,
  CarryOutOutlined
} from '@ant-design/icons-vue';

// 全局注册图标组件
const icons = {
  HomeOutlined,
  EditOutlined,
  HistoryOutlined,
  ApartmentOutlined,
  SolutionOutlined,
  FileOutlined,
  UploadOutlined,
  AuditOutlined,
  FileSearchOutlined,
  CheckOutlined,
  InfoCircleOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
  ClockCircleOutlined,
  ConnectionOutlined,
  ThunderboltOutlined,
  SearchOutlined,
  PlusOutlined,
  DeleteOutlined,
  ExclamationCircleOutlined,
  DownloadOutlined,
  TableOutlined,
  LinkOutlined,
  FormOutlined,
  FilterOutlined,
  FunctionOutlined,
  TranslationOutlined,
  CarryOutOutlined
};

// 注册全局图标组件
Object.keys(icons).forEach(name => {
  app.component(name, icons[name]);
});

// 挂载应用
app.mount('#app')

// 全局渲染检查机制
const setupGlobalRenderCheck = () => {
  console.log('[RENDER-CHECK] 设置全局渲染检查机制');
  
  // 在CSS加载后进行检查
  window.addEventListener('load', () => {
    console.log('[RENDER-CHECK] 窗口加载完成，开始检查渲染');
    checkAndFixRendering();
  });
  
  // 页面加载完成后定期检查
  document.addEventListener('DOMContentLoaded', () => {
    console.log('[RENDER-CHECK] DOM内容加载完成，开始检查渲染');
    // 立即检查一次
    checkAndFixRendering();
    
    // 定期检查
    [500, 1000, 2000, 3000, 5000].forEach(delay => {
      setTimeout(checkAndFixRendering, delay);
    });
    
    // 设置一个循环检查机制
    setInterval(checkAndFixRendering, 10000);
  });
  
  // 创建一个可全局访问的函数
  window.forceDDIRendering = checkAndFixRendering;
};

const checkAndFixRendering = () => {
  console.log('[RENDER-CHECK] 检查并修复页面渲染');
  
  // 全局样式修复
  const fixGlobalStyles = () => {
    if (document.getElementById('force-render-styles')) {
      return; // 已经存在样式，不重复添加
    }
    
    const style = document.createElement('style');
    style.id = 'force-render-styles';
    style.textContent = `
      /* 只针对关键容器应用必要的可见性样式 */
      .el-tabs__content, .el-tab-pane {
        visibility: visible !important;
        height: auto !important;
        overflow: visible !important;
      }
      
      /* 表格相关样式 - 保持正常显示格式 */
      table { 
        visibility: visible !important; 
      }
      
      /* 紧急数据容器的样式 */
      #emergency-container, #provider-data-container, #force-created-container {
        visibility: visible !important;
        display: block !important;
        min-height: 50px !important;
      }
    `;
    document.head.appendChild(style);
    console.log('[RENDER-CHECK] 添加了合理的渲染修复样式');
  };
  
  // 检查并固定特定页面的渲染
  const fixDDIPageRendering = () => {
    // 检查是否在DDI页面
    const isDDIPage = window.location.hash.includes('ddi-management');
    if (!isDDIPage) {
      return;
    }
    
    console.log('[RENDER-CHECK] 当前在DDI管理页面，执行特定修复');
    
    // 查找紧急容器
    let emergencyContainer = document.getElementById('emergency-container');
    
    // 如果找不到紧急容器，在标签页内创建一个
    if (!emergencyContainer) {
      const activePane = document.querySelector('.el-tab-pane.is-active');
      if (activePane) {
        console.log('[RENDER-CHECK] 在活动标签页中创建紧急容器');
        emergencyContainer = document.createElement('div');
        emergencyContainer.id = 'emergency-container';
        emergencyContainer.style.cssText = 'border: 2px solid #e74c3c; padding: 15px; margin: 15px 0; background-color: #f9f9f9; border-radius: 4px;';
        
        // 找到合适的插入位置
        const targetContainer = activePane.querySelector('.provider-accounts-tab') || activePane;
        targetContainer.prepend(emergencyContainer);
      } else {
        // 如果找不到活动标签页，尝试找到任何标签页
        const anyPane = document.querySelector('.el-tab-pane');
        if (anyPane) {
          console.log('[RENDER-CHECK] 在找到的标签页中创建紧急容器');
          emergencyContainer = document.createElement('div');
          emergencyContainer.id = 'emergency-container';
          emergencyContainer.style.cssText = 'border: 2px solid #e74c3c; padding: 15px; margin: 15px 0; background-color: #f9f9f9; border-radius: 4px;';
          
          // 找到合适的插入位置
          const targetContainer = anyPane.querySelector('.provider-accounts-tab') || anyPane;
          targetContainer.prepend(emergencyContainer);
        }
      }
    }
    
    // 如果找到或创建了紧急容器，填充内容
    if (emergencyContainer) {
      console.log('[RENDER-CHECK] 找到紧急容器，填充内容');
      emergencyContainer.innerHTML = `
        <div style="color: #e74c3c; font-weight: bold; margin-bottom: 10px;">应急数据显示 (${new Date().toLocaleTimeString()})</div>
        <table style="width: 100%; border-collapse: collapse;">
          <thead>
            <tr>
              <th style="padding: 8px; text-align: left; border-bottom: 2px solid #ddd; background-color: #f2f2f2;">ID</th>
              <th style="padding: 8px; text-align: left; border-bottom: 2px solid #ddd; background-color: #f2f2f2;">名称</th>
              <th style="padding: 8px; text-align: left; border-bottom: 2px solid #ddd; background-color: #f2f2f2;">代码</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td style="padding: 8px; border-bottom: 1px solid #ddd;">1</td>
              <td style="padding: 8px; border-bottom: 1px solid #ddd;">广州医云</td>
              <td style="padding: 8px; border-bottom: 1px solid #ddd;">guangzhou</td>
            </tr>
            <tr>
              <td style="padding: 8px; border-bottom: 1px solid #ddd;">2</td>
              <td style="padding: 8px; border-bottom: 1px solid #ddd;">浙江英特</td>
              <td style="padding: 8px; border-bottom: 1px solid #ddd;">zhejiang</td>
            </tr>
          </tbody>
        </table>
      `;
    }
  };
  
  // 执行修复
  fixGlobalStyles();
  fixDDIPageRendering();
};

// 实例化全局检查机制
if (!isProd) {
  setupGlobalRenderCheck();
}

// 导入客户类型初始化函数
// import { initializeDefaultCustomerTypes } from './services/customer-type-init';

// 应用初始化后，初始化客户类型数据
// 等待DOM完全加载后再初始化，避免与其他初始化冲突
window.addEventListener('DOMContentLoaded', () => {
  console.log('应用已加载完成');
  // console.log('初始化客户类型数据...');
  // initializeDefaultCustomerTypes()
  //   .then(() => {
  //     console.log('客户类型初始化完成');
  //   })
  //   .catch(error => {
  //     console.error('客户类型初始化失败:', error);
  //   });
}); 